export default {
  "home": "STARTSEITE",
  "news": "NEUIGKEITEN",
  "community": "COMMUNITY",
  "character": "CHARAKTERE",
  "world": "WELT EINSTELLUNGEN",
  "features": "FUNKTIONEN",
  "topUp": "AUFLADEN",
  "customerService": "KUNDENDIENST",
  "download": "DOWNLOAD",
  "moreDownload": "Weitere Download-Methoden",
  "screenshot": "SCREENSHOT",
  "video": "FILMISCH",
  "poster": "POSTER",
  "downloadGame": "DOWNLOAD",
  "scan": "Zum Download QR-Code scannen.",
  "prev": "Vorher",
  "next": "Nächstes",
  "moreNews": "INFORMATION",
  "latest": "NEUESTE",
  "fwtk": "NUTZUNGSBEDINGUNGEN",
  "yszc": "DATENSCHUTZ-BESTIMMUNGEN",
  "noContent": "Noch kein Inhalt",
  "goPay": "LOS GEHT‘S",
  "payGuide": "MEHR ERFAHREN",
  "stayTurn": "Bleib dran!",
  "hero1": "Richard",
  "hero1_text": "Richard I., auch bekannt als Richard Löwenherz, wurde am 6. Juli 1189 zum König von England gekrönt. Er gilt als großer militärischer Anführer und Krieger.",
  "hero1_skill1": "König der Kreuzritter",
  "hero1_skill2": "Königliche Garde",
  "hero1_skill3": "Löwenherz",
  "hero1_skill4": "Energieboost",
  "hero2": "Alexander der Große",
  "hero2_text": "Alexander III. von Mazedonien, allgemein bekannt als Alexander der Große, war König des antiken griechischen Königreichs Mazedonien. Alexander bemühte sich, die „Enden der Welt und das Große Äußere Meer“ zu erreichen und führte unzählige Kriege.",
  "hero2_skill1": "Der Sohn Gottes",
  "hero2_skill2": "Begleiter",
  "hero2_skill3": "Einsamer Marsch",
  "hero2_skill4": "Mazedonische Phalanx",
  "hero3": "Mulan",
  "hero3_text": "Hua Mulan ist eine legendäre Volksheldin aus der Zeit der nördlichen und südlichen Dynastien (4. bis 6. Jahrhundert n. Chr.) der chinesischen Geschichte. Laut der Ballade von Mulan verkleidet sich Mulan als Mann, um den Platz ihres alternden Vaters in der Armee einzunehmen.",
  "hero3_skill1": "Kraftschuss",
  "hero3_skill2": "Volksheldin",
  "hero3_skill3": "Pflicht ruft",
  "hero3_skill4": "Landverteidiger",
  "hero4": "Königin Seondeok von Silla",
  "hero4_text": "Königin Seondeok von Silla regierte von 632 bis 647 als regierende Königin von Silla, einem der drei Königreiche Koreas. Sie war Sillas siebenundzwanzigste Herrscherin und ihre erste regierende Königin.",
  "hero4_skill1": "Wohlwollend",
  "hero4_skill2": "Schlagfertig",
  "hero4_skill3": "Eroberer",
  "hero4_skill4": "Amnestie",
  "hero5": "Nobunaga",
  "hero5_text": "Oda Nobunaga (23. Juni 1534 – 21. Juni 1582) war ein japanischer Daimyō und eine der führenden Persönlichkeiten der Sengoku-Zeit. Er gilt als der erste „Große Vereiniger“ Japans. Nobunaga war eine einflussreiche Persönlichkeit in der japanischen Geschichte und gilt zusammen mit seinen Gefolgsleuten Toyotomi Hideyoshi und Tokugawa Ieyasu als einer der drei großen Vereiniger Japans.",
  "hero5_skill1": "Tenka Fubu",
  "hero5_skill2": "Barriere",
  "hero5_skill3": "Tsubame Gaeshi",
  "hero5_skill4": "Bushido",
  "hero6": "Jeanne d'Arc",
  "hero6_text": "Jeanne d'Arc ist eine Schutzpatronin Frankreichs, die als Verteidigerin der französischen Nation geehrt wird. Sie behauptete, ein göttliches Mandat zu besitzen, wurde eine Militärführerin, die die Geschlechterrollen überwand und als Retterin Frankreichs anerkannt wurde.",
  "hero6_skill1": "Engelssegen",
  "hero6_skill2": "Jeanne",
  "hero6_skill3": "Glaube",
  "hero6_skill4": "Station der Unantastbarkeit",
  "roleMainTitle": "Rekrutiere historische Legenden",
  "roleSubTitle": "Game of Empires bietet dir die Möglichkeit, eine ganze Reihe legendärer historischer Persönlichkeiten zu rekrutieren, um dein Imperium zu erweitern.",
  "back": "Zurück",
  "slogan": "Baue dein eigenes Imperium auf",
}
